module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"save":"Save","title":"Blackboard Designer","validationError":"You must add all grid items","fullPreview":"Full preview"},"es":{"save":"Guardar","title":"Diseñador de Pizarras","validationError":"Se deben agregar todos los elementos en la plantilla","fullPreview":"Preview completo"}}')
  delete Component.options._Ctor
}
